import Component from '@glimmer/component'
import { on } from '@ember/modifier'
import { LinkTo } from '@ember/routing'
import { array } from '@ember/helper'
import { hash } from '@ember/helper'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface TileButtonArgs {
  title: string
  themeKey: ThemeKeys.blue | ThemeKeys.orange | ThemeKeys.pink | ThemeKeys.purple
  models?: unknown[]
  route?: string
  query?: Record<string, string | number>
  action?: () => void
}

interface TileButtonSignature {
  Args: TileButtonArgs
  Element: Element
}

const themes: Record<ThemeKeys.blue | ThemeKeys.purple | ThemeKeys.orange | ThemeKeys.pink, string> = {
  [ThemeKeys.blue]:
    'border-oceany-blue-300 bg-oceany-blue-300 hover:bg-oceany-blue-325 focus:bg-oceany-blue-325 text-white hover:text-white focus:text-white text-white',
  [ThemeKeys.purple]:
    'border-rexy-purple-300 bg-rexy-purple-300 hover:bg-rexy-purple-400 focus:bg-rexy-purple-400text-white hover:text-white focus:text-white text-white',
  [ThemeKeys.orange]:
    'border-orange-350 bg-juicy-orange-200 hover:bg-orange-350 focus:bg-orange-350 text-dusty-black-300 hover:text-dusty-black-300 focus:text-dusty-black-300',
  [ThemeKeys.pink]:
    'border-purply-pink-300 bg-purply-pink-300 hover:bg-purply-pink-350 focus:bg-purply-pink-350 text-white hover:text-white focus:text-white text-white',
}

const defaultStyle =
  'inline-block w-full select-none rounded-md border px-5 py-2 text-center align-middle no-underline transition-all duration-200'

export class TileButton extends Component<TileButtonSignature> {
  get theme() {
    return themes[this.args.themeKey]
  }

  <template>
    {{#if @action}}
      <button type="button" class="{{this.theme}} {{defaultStyle}}" {{on "click" @action}} data-test-homeschool-button>
        {{@title}}
      </button>
    {{else}}
      <LinkTo
        @route={{@route}}
        @models={{if @models @models (array)}}
        @query={{if @query @query (hash)}}
        class="{{this.theme}} {{defaultStyle}}"
        data-test-homeschool-button
      >
        {{@title}}
      </LinkTo>
    {{/if}}
  </template>
}

export default TileButton
